import { utils } from "../../utils"

const Action_toggleSideMenu = () => (dispatch, getState) => {

    // console.log('entering Action_toggleSideMenu');

// console.log('    getState().reducer_ALL.isMenuOpen.left:',     getState().reducer_ALL.isMenuOpen.left)


    dispatch({
        type: utils.constants.MENU_TOGGLE,
        payload: {
            isMenuOpen: { left: !getState().reducer_ALL.isMenuOpen.left }
        }
    })

}

const Action_openSideMenu = () => (dispatch) => {

    dispatch({
        type: utils.constants.MENU_OPEN,
        payload: {
            isMenuOpen: { left: true }
        }
    })

}

const Action_LoginsOpener = (isLoginsOpen) => (dispatch) => {

    // console.log('isLoginsOpen:', isLoginsOpen)
    dispatch({
        type: utils.constants.LOGINS_OPENER,
        payload: isLoginsOpen
    })

}

const Action_MessageModalOpener = (isOpen, msg, title) => (dispatch) => {

    dispatch({
        type: utils.constants.MSG_MODAL_OPENER,
        payload: isOpen ? { isOpen, msg, title } : { isOpen }
    })

}


export {
    Action_toggleSideMenu,
    Action_openSideMenu,
    Action_LoginsOpener,
    Action_MessageModalOpener
}